import { Component, inject, signal } from '@angular/core';
import { CommandBus, QueryBus, RootContext, RootContextBase } from '@skylab-angular-shared/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { CompanyConfigUrlsQuery, LaboratoryInfoQuery, LaboratoryRefreshInfoCommand } from '@skylab-shared/business';
import { ConsoleLogger } from '@skylab-shared/core';
import { IconComponent, TooltipDirective } from '@skylab-angular-shared/ui';

@Component({
	selector: 'skl-orders-lab-inactive-banner',
	template: `
		<div class="align--form">
			<span class="message-box-info">
				<skl-icon name="exclamation-circle" size="16px"></skl-icon>
				<div>
					<a class="laboratory-link link link--dotted align--tiny-right" target="_blank" [href]="labUrl()">{{'scenes.shared.order-lab-inactive-banner.prefix' | translate}}</a>
					<span>{{'scenes.shared.order-lab-inactive-banner.text' | translate}}</span>

				</div>
				<skl-icon
					(click)="refreshLaboratoryLicenseAsync()"
					[class]="{ 'spinning':  isLicenseRefreshing() }"
					[tooltip]="'scenes.configuration.shared.ksef.messages.lab-disabled.refresh' | translate"
					name="refresh">
				</skl-icon>
			</span>
		</div>
	`,
	styles: `
		.laboratory-link {
			line-height: 1;
		}
	`,
	imports: [TranslatePipe, IconComponent, TooltipDirective]
})
export class OrdersLabInactiveBannerComponent {
	readonly #rootContext = inject(RootContext) as any as RootContextBase;
	readonly #queryBus = inject(QueryBus);
	readonly #commandBus = inject(CommandBus);
	readonly #logger = new ConsoleLogger(this.constructor.name);

	public readonly labUrl = signal('');
	public readonly isLicenseRefreshing = signal(false);

	public constructor() {
		this.#rootContext.preload(CompanyConfigUrlsQuery).then((d) => {
			this.labUrl.set(d.ordersLab);
		});
	}

	public async refreshLaboratoryLicenseAsync(): Promise<void> {
		if (this.isLicenseRefreshing()) return;

		try {
			this.isLicenseRefreshing.set(true);

			const isLaboratoryRefreshed = await this.#commandBus.commandAsync(new LaboratoryRefreshInfoCommand());
			if (!isLaboratoryRefreshed) return;

			const active = (await this.#queryBus.queryAsync(new LaboratoryInfoQuery()))?.some(elem => elem.context === 'SKYLAB_ORDERS');
			if (!active) return;

			document.location.reload();
		} catch (err) {
			this.#logger.error(err);
		} finally {
			this.isLicenseRefreshing.set(false);
		}
	}
}
